import UniversalWebView from '@/components/UniversalWebView'
import type { UniversalWebViewRef } from '@/components/universalWebView/types'
import { getAuthToken } from '@/lib/api/authToken'
import { usePostKeyboardEventsToWebView } from '@/lib/hooks/usePostKeyboardEventsToWebView'
import FormStackScreen from '@/views/forms/FormStackScreen'
import { useLocalSearchParams } from 'expo-router'
import { useMemo, useRef } from 'react'
import { Platform, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function Page() {
  const insets = useSafeAreaInsets()
  const { token: formToken } = useLocalSearchParams<{ token: string }>()
  const webviewRef = useRef<UniversalWebViewRef>(null)
  usePostKeyboardEventsToWebView(webviewRef)

  const uri = useMemo(() => {
    const token = getAuthToken()
    return `${process.env.EXPO_PUBLIC_NEXT_BASE_URL}/m/participated_forms/${formToken}/entries?m_t=${token}`
  }, [formToken])

  return (
    <View className="flex-1" style={Platform.OS === 'android' ? { paddingBottom: insets.bottom } : undefined}>
      <FormStackScreen
        formToken={formToken}
        titlePrefix="记录详情"
        headerTransparent={false}
        defaultBackHref="/participated_forms"
      />
      <UniversalWebView ref={webviewRef} source={{ uri }} className="flex-1 bg-background-muted" />
    </View>
  )
}
